import { useEffect, useState } from 'react';

const navItems = [
  { label: 'Como funciona', id: 'como-funciona' },
  { label: 'Planes', id: 'planes' },
  { label: 'App Coverly', id: 'app-coverly' },
  { label: 'Beneficios', id: 'beneficios' },
  { label: 'FAQ', id: 'faq' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    setMenuOpen(false);
  };

  const openRegistration = () => {
    const el = document.getElementById('cta-final');
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    setMenuOpen(false);
  };

  return (
    <nav
      className={`fixed left-0 right-0 top-0 z-50 transition-all duration-300 ${
        scrolled || menuOpen ? 'border-b border-[#E5E1F7] bg-white/92 backdrop-blur-xl' : 'bg-white/80 backdrop-blur-md'
      }`}
    >
      <div className="mx-auto flex h-16 max-w-7xl items-center justify-between px-4 md:h-20 md:px-6">
        <button onClick={() => scrollTo('hero')} className="flex items-end gap-0" aria-label="Coverly inicio">
          <span className="font-title text-[1.55rem] font-black leading-none tracking-tight text-[#171421] md:text-2xl">Cover</span>
          <span className="font-title text-[1.55rem] font-black leading-none tracking-tight text-[#9E98E8] md:text-2xl">ly</span>
        </button>

        <div className="hidden items-center gap-7 md:flex">
          {navItems.map((item) => (
            <button
              key={item.id}
              onClick={() => scrollTo(item.id)}
              className="text-sm font-semibold text-[#565166] transition-colors hover:text-[#534AB7]"
            >
              {item.label}
            </button>
          ))}
        </div>

        <div className="hidden items-center gap-3 md:flex">
          <a
            href="https://app.coverly.com.mx"
            target="_blank"
            rel="noopener noreferrer"
            className="rounded-full border border-[#D9D5F3] px-4 py-2 text-sm font-bold text-[#534AB7] transition-colors hover:bg-[#F3F1FF]"
          >
            Entrar a la app
          </a>
          <button
            onClick={openRegistration}
            className="rounded-full bg-[#534AB7] px-5 py-2.5 text-sm font-black text-white shadow-lg shadow-[#534AB7]/20 transition-transform hover:scale-[1.02]"
          >
            Crear membresia
          </button>
        </div>

        <button
          className="flex h-10 w-10 items-center justify-center rounded-full text-[#302B45] md:hidden"
          onClick={() => setMenuOpen((value) => !value)}
          aria-label="Menu"
        >
          <i className={`${menuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl`} />
        </button>
      </div>

      <div className={`overflow-hidden border-[#E5E1F7] bg-white transition-all duration-300 md:hidden ${menuOpen ? 'max-h-[440px] border-t' : 'max-h-0'}`}>
        <div className="flex flex-col gap-2 px-4 py-4">
          {navItems.map((item) => (
            <button
              key={item.id}
              onClick={() => scrollTo(item.id)}
              className="rounded-2xl px-4 py-3 text-left text-sm font-bold text-[#454052] hover:bg-[#F7F6FF]"
            >
              {item.label}
            </button>
          ))}
          <a
            href="https://app.coverly.com.mx"
            target="_blank"
            rel="noopener noreferrer"
            className="rounded-2xl border border-[#E2DEF8] px-4 py-3 text-center text-sm font-bold text-[#534AB7]"
          >
            Entrar a la app
          </a>
          <button
            onClick={openRegistration}
            className="rounded-2xl bg-[#534AB7] px-4 py-3 text-sm font-black text-white"
          >
            Crear membresia
          </button>
        </div>
      </div>
    </nav>
  );
}
